export function useFormattedText() {
  const { n, t } = useI18n()
  const storeStore = useStoreStore()

  const getMoneyFormattedText = (amount: number, withDecimal: boolean = true) => {
    const amountWithRate = +amount * storeStore.currencyRate
    return n(amountWithRate, {
      key: withDecimal ? 'currency' : 'currencyWithoutDecimal',
      currency: storeStore.currencyCode
    })
  }

  const getRewardFormattedText = (rewardText: string, amount: number | undefined, key: string) => {
    if (amount === undefined) return rewardText
    return rewardText.replace(`{{${key}}}`, `<span class="weglot-ignore">${getMoneyFormattedText(amount)}</span>`)
  }

  const getRewardFormattedTextWithType = (text: string, amount: number, key: string, type: number) => {
    switch (type) {
      case 1: {
        return text.replace(`{{${key}}}`, t('Points', amount))
      }
      case 2: {
        return text.replace(`{{${key}}}`, `<span class="weglot-ignore">${n(amount / 100, 'percent')}</span>`)
      }
      case 3: {
        return getRewardFormattedText(text, amount, key)
      }
      default: {
        return text
      }
    }
  }

  return { getMoneyFormattedText, getRewardFormattedText, getRewardFormattedTextWithType }
}
